import F2 from "@/utils/f2.js";
import qs from "qs";
import { SELF, MATE, CHILD } from "@/enum/RELATION.js";
export default {
    props: ["data"],
    data() {
        return {
            guaranteedMax: 0,
            memberList: this.data.memberRecommends,
            chartData: [],
            title: "报告页-测评获客版",
            copyImg: null,
            tmrId: "",
        };
    },
    created() {
        let query = qs.parse(location.search.slice(1));
        if (query.tmrId) {
            this.title = "报告页-企业微信版客户端";
            this.tmrId = query.tmrId;
        }
        this.productAlias = {
            serious: "重疾",
            medical: "医疗",
            accident: "意外",
            pension: "养老",
            life: "寿险",
            inherited: "传承",
        };
        this.seriousLabel = [
            {
                min: 0,
                max: 17,
                gender: 0,
                desc:
                    "未成年人的重大疾病风险不容小觑，据国际儿童肿瘤学会调查显示，儿童肿瘤发病率近十年以年均2.8%左右的速度增长，中国每年新增3~4万名儿童恶性肿瘤患者。小概率事件一旦降临就是不可预估的灾难，给我们的孩子一份保障，守护的是整个家庭。",
            },
            {
                min: 0,
                max: 17,
                gender: 1,
                desc:
                    "未成年人的重大疾病风险不容小觑，据国际儿童肿瘤学会调查显示，儿童肿瘤发病率近十年以年均2.8%左右的速度增长，中国每年新增3~4万名儿童恶性肿瘤患者。小概率事件一旦降临就是不可预估的灾难，给我们的孩子一份保障，守护的是整个家庭。",
            },
            {
                min: 18,
                max: 40,
                gender: 0,
                desc:
                    "据我国卫生部数据，重疾恶性肿瘤、急性心肌梗塞等六种常见重疾呈现年轻化趋势；<br>男性高发恶性肿瘤的肺癌、肝癌等，与男性吸烟、饮酒及饮食习惯具有强关联性。",
            },
            {
                min: 18,
                max: 40,
                gender: 1,
                desc:
                    "据我国卫生部数据，恶性肿瘤、急性心肌梗塞等六种常见重疾呈现年轻化趋势；<br>据《中国乳腺疾病调查报告》数据显示，近年我国乳腺癌发病率的增长速度高出高发国家1~2个百分点，2003年—2009年，我国城市中乳腺癌的死亡率增长了38.91%。另外在重大疾病中，宫颈癌、卵巢癌也是女性的“健康杀手”。",
            },
            {
                min: 41,
                max: 150,
                gender: 0,
                desc:
                    "据我国卫生部数据，恶性肿瘤、急性心肌梗塞等六种常见重疾呈现年轻化趋势；<br>多家保险公司综合理赔报告数据显示，步入中年疾病高发期，同年龄男性重大疾病发病率高于女性，饮食控制不佳，应酬多等均为重要因素。",
            },
            {
                min: 41,
                max: 150,
                gender: 1,
                desc:
                    "多家保险公司综合理赔报告数据显示，40岁以上的女性最高发的重疾为恶性肿瘤、脑中风后遗症、急性心肌梗死。<br>据《2020 全球癌症报告》数据显示，2020 年女性乳腺癌新发 226 万例，远超女性其他癌症类型。<br>在这个年龄阶段，面临的是照顾家庭和事业上的双重压力，为家庭倾注心血的同时，也要时刻照顾好自己的身体。",
            },
        ];
    },
    mounted() {
        window.addEventListener("orientationchange", this.repaintEvent);
    },
    methods: {
        parseChartData(data = this.activeMember) {
            this.chartData = [];
            let obj = data.guaranteeds;
            let expObj = data.shouldGuaranteed;
            let minObj = data.minGuaranteed;
            let maxTick = Math.max(
                ...Object.values(obj),
                ...Object.values(expObj),
                ...Object.values(minObj)
            );
            let minTick = maxTick / 10;
            this.guaranteedMax = maxTick;
            for (const key in obj) {
                let singleMax = Math.max(obj[key], expObj[key], minObj[key]);
                let rate = maxTick / singleMax;
                this.chartData.push({
                    item: this.productAlias[key],
                    user: "目前保障",
                    score:
                        obj[key] * rate > minTick ? obj[key] * rate : minTick,
                });
                this.chartData.push({
                    item: this.productAlias[key],
                    user: "应有保障",
                    score:
                        expObj[key] * rate > minTick
                            ? expObj[key] * rate
                            : minTick,
                });
            }
        },
        renderChart(id) {
            if (!this.chartData.length) {
                return;
            }
            const canvas = this.$refs.canvas || this.$refs[id][0];
            const { width, height } = canvas.parentNode.getBoundingClientRect();
            const copyImg = id || "copyImg";
            this[copyImg] &&
                (this[copyImg].src =
                    "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg==");
            let chart = (this.chart = new F2.Chart({
                el: canvas,
                pixelRatio: window.devicePixelRatio,
                width,
                height,
            }));
            chart.coord("polar");
            chart.legend(false);
            chart.source(this.chartData, {
                score: {
                    min: 0,
                    max: this.guaranteedMax,
                    tickCount: 4,
                },
            });
            chart.tooltip(false);
            chart.axis("score", {
                label: null,
                grid: {
                    lineDash: null,
                },
            });
            chart.axis("item", {
                labelOffset: 12,
                label: (text, index, total) => {
                    return {
                        fontSize: "16",
                        fill: "#0F2742",
                    };
                },
                grid: {
                    lineDash: null,
                },
            });
            chart
                .area()
                .position("item*score")
                .color("user", ["#FF7878", "#12BA8F"])
                .animate({
                    appear: {
                        animation: "groupWaveIn",
                    },
                });
            chart
                .line()
                .position("item*score")
                .color("user", ["#FF7878", "#12BA8F"])
                .size(1)
                .animate({
                    appear: {
                        animation: "groupWaveIn",
                    },
                });
            chart.render();
            //canvas兼容同屏系统
            let query = qs.parse(location.search.slice(1));
            if (query.syncid && query.synctoken) {
                setTimeout(() => {
                    if (!this[copyImg]) {
                        this[copyImg] = new Image();
                        this[copyImg].style = "width:100%;height:100%;";
                        canvas.parentNode.appendChild(this[copyImg]);
                    }
                    this[copyImg].src = canvas.toDataURL();
                }, 500);
            }
        },
        riskShow(type, relation = this.activeMember.relation) {
            let flag = true;
            switch (relation) {
                case SELF:
                    if (this.data.hasChild == "N" && type == "inherited") {
                        flag = false;
                    }
                    break;
                case MATE:
                    if (type == "inherited") {
                        flag = false;
                    }
                    break;
                case CHILD:
                    if (type != "serious") {
                        flag = false;
                    }
                    break;
                default:
                    break;
            }
            return flag;
        },
        starRender(num, key) {
            return { active: key <= Math.ceil(num), half: num == 0.5 };
        },
    },
    destroyed() {
        window.removeEventListener("orientationchange", this.repaintEvent);
    },
};
